import { render, staticRenderFns } from "./HygieneManagementPlan.vue?vue&type=template&id=b0374090&"
import script from "./HygieneManagementPlan.vue?vue&type=script&lang=js&"
export * from "./HygieneManagementPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports